/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { Locale } from '../locale/Locale';
import { LocaleKeys } from '../locale/LocaleKeys';
import { AppError } from './AppError';

export class PostSignInError extends AppError {
    protected title: string = Locale.getString(LocaleKeys.TEMPORARY_SERVICE_CONNECTION_ISSUE_TITLE);

    protected description: string = '';

    protected type: string = '';

    constructor(message: string, code: string) {
        super(code, message);
    }

    public getDescription(): string {
        return this.description;
    }

    public getTitle(): string {
        return this.title;
    }

    public getType(): string {
        return this.type;
    }
}
